<template>
    <div class="pt-3 px-3">
        <p>{{ $t('home.notFound') }}</p>
    </div>
</template>

<script>
    export default {
        name: "NotFoundPage"
    };
</script>

<style scoped>

</style>